<app-whatsapp-template-preview [templateDisplayedBS]="templateDisplayedBS" [actualTime]="message['datetime']">
</app-whatsapp-template-preview>
